<template>
  <div v-if="folderFileData != null">
    <table class="table table-condense">
        <tbody>
            <tr v-if="folderFileData.parentFolder != null">
                <td>
                  <span class="pa-2">
                    <v-icon large color="orange darken-2">reply</v-icon>
                  </span>
                </td>
                <td>
                    
                    <a class="title" @click="onNavGPOContractFolder(folderFileData.parentFolder)" target="_blank"> Back To Parent Folder</a>
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr v-for="folder in folderFileData.subfolders" :key="folder.folderName">
                <td>
                
                  <span class="pa-2">
                    <v-icon large color="yellow darken-2">folder</v-icon>
                  </span>
                </td>
                <td>
                    <a class="title" @click="onNavGPOContractFolder(folder)"> {{folder.folderName}}</a>
                </td>
                <td></td>
                <td></td>
            </tr>

            <tr v-for="file in folderFileData.files" :key="file.fileName">
                <td>
                
                    <span class="pa-2" >
                      <v-icon large color="blue darken-2" v-if="file.docType == '.pdf'">picture_as_pdf</v-icon>
                      <v-icon large color="blue darken-2" v-else-if="file.docType == '.xlsx' || file.docType == '.xls'">grid_on</v-icon>
                      <v-icon large color="blue darken-2" v-else-if="file.docType == '.docx' || file.docType == '.doc'">article</v-icon>
                      <v-icon large color="blue darken-2" v-else>insert_drive_file</v-icon>
                    </span>
                </td>
                <td>
                    <a class="title" @click="onGetDoc(file)"> {{file.fileName}}</a>
                </td>
                <td class="px-3"> {{file.size}}M</td>
                <td> {{file.updateDate | morph-date("MM/DD/YYYY hh:mm a") }}</td>
            </tr>

        </tbody>
    </table>    
  </div>
</template>
<script>
  import {mapActions} from 'vuex'
  import ApiService from "@/services/api.service"
  export default {
    data: () => ({
      folderFileData: null,
    }),
    methods: {
      ...mapActions('folderFileNav', [
        'navGPOContractFolder'
      ]),
      async onNavGPOContractFolder(folder){
        this.folderFileData = await this.navGPOContractFolder(folder)
      },
      onGetDoc(fileData) {
          var url = `/api/FolderFileNav/downloadFile?file=${fileData.path}`
          var data = {
              method: 'GET',
              // url: fileData.path,
              url: url,
              responseType: 'blob'
          }
          ApiService.customRequest(data)
          .then((response) => {
              if (!window.navigator.msSaveOrOpenBlob){
                  // BLOB NAVIGATOR
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', fileData.fileName);//'download.pdf');
                  document.body.appendChild(link);
                  link.click();
              }else{
                  // BLOB FOR EXPLORER 11
                  const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]),fileData.fileName);//"download.pdf");
              }
              });
      },
    },
    created() {
      this.onNavGPOContractFolder(
        {
          folderName: '',
          path: '',
        }
      )
    }
  }
</script>